import { CustosEnvironment } from '../app/core/models/environment';

// Local dev: proxy.conf.js forwards /api → backend (SSH tunnel or local),
// injecting the API key server-side. No API key leaves the browser.
export const environment: CustosEnvironment = {
  isProduction: false,
  useMockApi: false,
  chainId: 11155111,
  rpcUrl: 'https://ethereum-sepolia-rpc.publicnode.com',
  walletConnectProjectId: '',
  apiBaseUrl: 'http://43.153.171.240:8000',
  authBaseUrl: "https://api.custos.global",
  apiKey: '', // Never set — proxy.conf.js injects the key server-side
  contracts: {
    rollocker: '0xcdBe5dF736fa0e576fDCf4cEcd6A2A66ACe1E277',
    prediction: '0x68f966e387610d1d2b5a9a84806219f3e0b9155f',
    ctsToken: '0x3147D3Fdbb50Cc7C3B612378E9F3DDC9e96F52Bb',
  },
  blockExplorerUrl: 'https://sepolia.etherscan.io',
};
